<template>
    <div>
        <div class="main_title t_style a_left s_title mt50">
            <div class="c_inner">
                <h2 class="c_title">ROOM SERVICES</h2>
            </div>
        </div>
        <div class="room_facilitys_list">
            <div class="all_facility_list">
                <div class="col-sm-4 nopadding">
                    <ul class="list-unstyled">
                        <li><i class="fa fa-check"></i>Double Bed</li>
                        <li><i class="fa fa-check"></i>80 Sq mt</li>
                        <li><i class="fa fa-check"></i>6 Persons</li>
                        <li><i class="fa fa-check"></i>Free Internet</li>
                    </ul>
                </div>
                <div class="col-sm-4 nopadding">
                    <ul class="list-unstyled">
                        <li><i class="fa fa-check"></i>Free Wi-Fi</li>
                        <li><i class="fa fa-check"></i>Breakfast Include</li>
                        <li><i class="fa fa-check"></i>Private Balcony</li>
                        <li class="no"><i class="fa fa-times"></i>Free Newspaper</li>
                    </ul>
                </div>
                <div class="col-sm-4 nopadding_left">
                    <ul class="list-unstyled">
                        <li class="no"><i class="fa fa-times"></i>Flat Screen Tv</li>
                        <li><i class="fa fa-check"></i>Full Ac</li>
                        <li class="no"><i class="fa fa-times"></i>Beach View</li>
                        <li><i class="fa fa-check"></i>Room Service</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {

    }
</script>


// WEBPACK FOOTER //
// roomServices.vue?4af3c31a